//#region IMPORTS
import { InstoreOrderType } from "../../models/instoreOrderType";
import InstoreOrderTypesTableRowActionEdit from "./InstoreOrderTypesTableRowActionEdit";
import MainTableRowActionDelete from "../_layout/MainTableRowActionDelete";
//#endregion

//#region INTERFACE
interface Props {
  deleteHandler: () => void;
  instoreOrderType: InstoreOrderType;
  editHandler: () => void;
  loading?: boolean;
}
//#endregion

export default function InstoreOrderTypesTableRow({
  deleteHandler,
  instoreOrderType,
  editHandler,
  loading,
}: Props) {
  //#region RENDER
  return (
    <tr className="border-t border-slate-300 h-10">
      {/* read */}
      <td className="whitespace-nowrap px-2 text-left text-xs text-gray-500 sm:pl-0">
        <InstoreOrderTypesTableRowActionEdit
          instoreOrderType={instoreOrderType}
          editHandler={editHandler}
          disabled={loading || instoreOrderType.name.toUpperCase() === "DEFAULT"}
        />
      </td>

      {/* name */}
      <td className="whitespace-nowrap px-2 text-left text-xs text-gray-500 sm:pl-0">
        {instoreOrderType.name}
      </td>

      {/* Delete */}
      <td className="whitespace-nowrap px-2 text-left text-xs text-gray-900">
        <MainTableRowActionDelete
          deleteHandler={deleteHandler}
          tooltipId={`instoreOrderType${instoreOrderType.id}`}
          disabled={loading}
        />
      </td>
    </tr>
  );
  //#endregion
}
